
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import { updateProblemModal } from './problemDetail';
export const GET_PROBLEM_LIST = "GET_PROBLEM_LIST";
export const UPDATE_PROBLEM_LOADING_STATUS = "UPDATE_PROBLEM_LOADING_STATUS";


message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PROBLEM_LOADING_STATUS,
      loading
    });
  };
}

export function getProblemList(params={}) {
  return (dispatch, getState) => {
    const { keyword='', current = 1, pageSize= 20 } = params;
    const defaultParam = {
      keyword,
      pageStart: parseInt(current) - 1,
      pageSize: parseInt(pageSize),
    };
    dispatch(updateLoadingStatus(true));
    let url = '/iot/config/api/iot/feedback/listAll';
    if(defaultParam.keyword) {
      url = `/iot/config/api/iot/feedback/search/${defaultParam.keyword}`;
    }
    delete defaultParam['keyword'];
    const fetchData = new FetchData(url, {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      body: defaultParam,
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(res => {
        dispatch(updateLoadingStatus(false));
        const { meta } = res;
        if (meta.code === 200) {
          const {
            data = {
              list: [],
              unreplyTotal: 0,
              total: 0
            }
          } = res;
          console.log(111111111111111)
          console.log(`data.unreplyTotal => ${data.unreplyTotal}`)
          dispatch({
            type: GET_PROBLEM_LIST,
            problemList: data.list,
            unreplyTotal: data.unreplyTotal,
            total: data.total,
            current,
            pageSize,
          });
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}

export function getProblemDetail(recordtId) {
  return (dispatch, getState) => {
    const defaultParam = {
      pageStart: 0,
      pageSize: 10,
    };
    const url = `/iot/config/api/iot/feedback/search/${recordtId}`;
    const fetchData = new FetchData(url, {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      body: defaultParam,
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(res => {
        const { meta } = res;
        if (meta.code === 200) {
          const {
            data = {
              list: [],
              total: 0
            }
          } = res;
          const { problemList, total, current, pageSize } = getState().problem;
          const newData = data.list.concat(problemList);
          const ids = [];
          const newList = [];
          newData.map(v => {
            if(ids.indexOf(v.recordId) == -1) {
              ids.push(v.recordId);
              newList.push(v);
            }
          })
          dispatch(updateProblemModal(data.list[0], true))
          // dispatch({
          //   type: GET_PROBLEM_LIST,
          //   problemList: newList,
          //   total,
          //   current,
          //   pageSize,
          // });
        }
      })
      .catch(e => {
      });
  };
}

